module.exports = __webpack_public_path__ + "static/media/LAPELS-LOLA-Logo.31440fc8.png";